import { render, staticRenderFns } from "./ModalCopiarOrden.vue?vue&type=template&id=3b9d75f2&scoped=true&"
import script from "./ModalCopiarOrden.vue?vue&type=script&lang=js&"
export * from "./ModalCopiarOrden.vue?vue&type=script&lang=js&"
import style0 from "./ModalCopiarOrden.vue?vue&type=style&index=0&id=3b9d75f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d75f2",
  null
  
)

export default component.exports